import { useCallback, useEffect, useRef } from 'react'
import { NeoniApi } from '../lib/api'

function useAccessScope(api: NeoniApi, key?: string) {
	const scope = useRef({ api, key, generation: 0 })
	const mounted = useRef(true)
	if (scope.current.api !== api || scope.current.key !== key) {
		scope.current = { api, key, generation: scope.current.generation + 1 }
	}

	useEffect(() => {
		mounted.current = true
		return () => { mounted.current = false }
	}, [])

	const isCurrent = useCallback((generation: number) =>
		mounted.current && scope.current.generation === generation, [])

	return { generation: scope.current.generation, isCurrent }
}

export default useAccessScope
